
import { defineComponent, ref, reactive } from 'vue'
import type { FormInstance, FormRules } from "element-plus";
import { errManager, showNotification } from "@/core/config/Tools";
import { useStore } from "vuex";
//services
import GlobalService from '@/core/services/GlobalService';
import { useI18n } from "vue-i18n/index";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

export default defineComponent({
    props: {
        itemDetails: {
            type: null,
            required: false,
            default: () => ({})
        },
    },
    setup(props, { emit }) {
        const { t } = useI18n();
        const store = useStore();
        const loading = ref(false);
        const titleDialog = ref('');
        const isModalVisible = ref(false);
        const form = reactive<any>({});
        const ruleFormRef = ref<FormInstance>();
        const rules = reactive<FormRules>({});
        
        const openModal = () => {
            isModalVisible.value = true
        };

        const onOpen = () => {
            titleDialog.value = 'Editar registro';
            Object.assign(form, props.itemDetails)
        }

        const onClosed = () => {}

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            const valid = await formEl.validate();
            if(!valid) return;

            //aqui
            emit("onUpdateItemOrderDetails", form);
            isModalVisible.value = false;
        };

        return {
            t,
            loading,
            titleDialog,
            isModalVisible,
            form,
            ruleFormRef,
            rules,

            //events
            openModal,
            onOpen,
            onClosed,
            submitForm

        }
    },
})
